import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useCustomMutation, useInvalidate } from "@refinedev/core";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTranslation } from "../../../../../hooks/useTranslation";

interface PriceSettingDeleteDialogProps {
  open: boolean;
  handleClose: () => void;
  rulesUrl: string;
}

export const PriceSettingDeleteDialog = (
  props: PriceSettingDeleteDialogProps,
) => {
  const { open, handleClose, rulesUrl } = props;

  const { isLoading: deleteLoading, mutate: deleteRule } = useCustomMutation();
  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.stores.pricingSettings",
  );
  const invalidate = useInvalidate();

  const handleDelete = () => {
    deleteRule(
      {
        url: `${rulesUrl}`,
        method: "delete",
        values: {},
        successNotification: () => {
          return {
            message: translate("successDelete"),
            type: "success",
          };
        },
      },
      {
        onSuccess: () => {
          invalidate({
            resource: "all",
            invalidates: ["all"],
          });

          handleClose();
        },
      },
    );
  };
  return (
    <Dialog open={open} onClose={deleteLoading ? undefined : handleClose}>
      <DialogTitle>{translate("delete.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{translate("delete.description")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={deleteLoading}>
          {translateWithoutPrefix("buttons.cancel")}
        </Button>
        <LoadingButton onClick={handleDelete} autoFocus loading={deleteLoading}>
          {translateWithoutPrefix("buttons.delete")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
